import { createSelector } from "reselect";

const currentUser = state => state.rootReducer.currentUserDetails;
export const selectCurrentUser = createSelector([currentUser], currentUser => currentUser);

const organizations = state => state.rootReducer.organizations;
export const selectOrganizations = createSelector([organizations], orgs => orgs);
